const defaultCurrentMandatoryTabIndex = 0

const tabs = {
  NewRollbackPlan: () => import('@/views/management/Resignation/rollback-plan'),
  NewResignationRequest: () => import('@/views/management/Resignation/resignation-request')
}

const state = {
  currentMandatoryResignationTabIndex: defaultCurrentMandatoryTabIndex,
  currentNewResignationTab: tabs.NewResignationRequest,
  tabs
}

const getters = {}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentNewResignationTab = state.tabs[tab]
  },

  SET_CURRENTMANDATORYTABINDEX: (state, payload) => {
    state.currentMandatoryResignationTabIndex = payload
  }
}

const actions = {
  setCurrentMandatoryResignationTab({ commit }, tab) {
    commit('SET_TABS', tab)
  },
  setCurrentMandatoryTabIndex({ commit }, currentTabIndex) {
    commit('SET_CURRENTMANDATORYTABINDEX', currentTabIndex)
  },
  clearCurrentMandatoryTabIndex({ commit }) {
    const defaultCurrentMandatoryTabIndex = 0
    commit('SET_CURRENTMANDATORYTABINDEX', defaultCurrentMandatoryTabIndex)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
